var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 455.9 455.9" },
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 455.9 455.9",
        "xml:space": "preserve",
        id: _vm.id,
      },
    },
    [
      _c("svg:style", { attrs: { type: "text/css" } }, [
        _vm._v(
          "\n            #" +
            _vm._s(_vm.id) +
            " > .b4-st0 {\n                 fill: " +
            _vm._s(_vm.color) +
            ";\n             }\n            #" +
            _vm._s(_vm.id) +
            " > .b4-st1 {\n                 fill: #ffffff;\n             }\n        "
        ),
      ]),
      _vm._v(" "),
      _c("circle", {
        staticClass: "b4-st0",
        attrs: { cx: "228", cy: "228", r: "228" },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "b4-st1",
        attrs: {
          d: "M371.6,251.9v-75.2c0-30.5-24.1-55.4-53.7-55.4H150.7c-29.6,0-53.7,24.8-53.7,55.4v75.2\n\tc0,27.8,20.2,51.4,46.9,54.9l7,0.9l-25,53.6l115.7-54.1h76.4C347.5,307.2,371.6,282.4,371.6,251.9z M139.6,173.6\n\tc-0.1-6.8,5.4-12.4,12.2-12.5h171.2c6.8,0.1,12.2,5.7,12.2,12.5l0,0c0.1,6.8-5.3,12.4-12.2,12.5H151.7\n\tC144.9,186,139.5,180.4,139.6,173.6L139.6,173.6z M139.6,215.3c-0.1-6.8,5.4-12.4,12.2-12.5h126.6c6.8,0.1,12.2,5.7,12.2,12.5l0,0\n\tc0.1,6.8-5.4,12.4-12.2,12.5H151.7C144.9,227.7,139.5,222.1,139.6,215.3L139.6,215.3z M150.7,270.7c-6.9-0.2-12.4-6-12.2-12.9\n\tc0.2-6.6,5.5-12,12.2-12.2h171.2c6.9,0.2,12.4,6,12.2,12.9c-0.2,6.6-5.5,12-12.2,12.2H150.7z",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }